// extracted by mini-css-extract-plugin
export default {"add":"resend-invitation-button_add__4Jl8P","error":"resend-invitation-button_error__0cV-X","success":"resend-invitation-button_success__P-Ny4 resend-invitation-button_error__0cV-X"};